<ng-container *ngIf="breadcrumbs.length">
<section class="portlet">
  <div class="portlet-content">
    <div class=" portlet-content-container">
      <div class="portlet-body">
          <div class="container contacts__breadcrumb">
            <ol class="contacts__breadcrumb-list breadcrumb-list">
              <li class="breadcrumb-list__item">
                <a routerLink="/{{this.selectedVpo?.code}}">Главная</a>
              </li>
              <li class="breadcrumb-list__item" *ngFor="let b of breadcrumbs">
                <ng-container *ngIf="selectedStructure.id !== b?.id">
                    <a routerLink="/{{this.selectedVpo?.code}}/{{b?.path}}">{{b?.title}}</a>
                </ng-container>
                <ng-container *ngIf="selectedStructure.id === b?.id">
                  <span><strong>{{b?.title}}</strong></span>
                </ng-container>
              </li>
            </ol>
          </div>
      </div>
    </div>
  </div>
</section>
</ng-container>
